import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../Core/Store";
import { defaultDateStrings } from "../Constants";

interface DataTypesSliceState {
  alarms: boolean;
  triggers: boolean;
  manualOperations: boolean;
  // cameraRecordEvents: boolean;
}
const getInitialState = () => {
  const savedDataTypesFilters = JSON.parse(
    localStorage.getItem("dataTypesFilters")
  );
  if (savedDataTypesFilters != null && savedDataTypesFilters != undefined) {
    return savedDataTypesFilters;
  }
  return {
    alarms: true,
    triggers: true,
    manualOperations: false,
    // cameraRecordEvents: false,
  };
};
export const initialState: DataTypesSliceState = getInitialState();

const dataTypesSlice = createSlice({
  name: "datatypes",
  initialState,
  reducers: {
    updateDataTypesParams: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateDataTypesParams } = dataTypesSlice.actions;

export const getDataTypesSelector = (state: RootState) => state.datatypes;

export default dataTypesSlice.reducer;
